import { render, staticRenderFns } from "./CaribbeanPickBoard.vue?vue&type=template&id=405d62dd&scoped=true&"
import script from "./CaribbeanPickBoard.vue?vue&type=script&lang=js&"
export * from "./CaribbeanPickBoard.vue?vue&type=script&lang=js&"
import style0 from "./CaribbeanPickBoard.vue?vue&type=style&index=0&id=405d62dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405d62dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VFlex,VImg,VRow})
